import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '~/design-system/foundations/Breadcrumb'
import {HgBreadcrumbItem} from './HgBreadcrumbItem'
import {HgBreadcrumbOverflowMenu} from './HgBreadcrumbOverflowMenu'
import {type BreadcrumbLinkProps, type HgBreadcrumbProps} from './types'

const NUM_VISIBLE_BREADCRUMBS = 3

function HgBreadcrumbListDefault({
  breadcrumbs,
}: {
  breadcrumbs: BreadcrumbLinkProps[]
}) {
  return breadcrumbs.map((breadcrumb, index) => (
    <HgBreadcrumbItem
      key={index}
      breadcrumb={breadcrumb}
      withSeparator={index < breadcrumbs.length - 1}
    />
  ))
}

function HgBreadcrumbListOverflow({
  breadcrumbs,
}: {
  breadcrumbs: BreadcrumbLinkProps[]
}) {
  const numOverflowBreadcrumbs = breadcrumbs.length - NUM_VISIBLE_BREADCRUMBS
  return (
    <>
      <HgBreadcrumbItem breadcrumb={breadcrumbs[0]} withSeparator={true} />
      <BreadcrumbItem>
        <HgBreadcrumbOverflowMenu
          breadcrumbs={breadcrumbs.slice(1, 1 + numOverflowBreadcrumbs)}
        />
      </BreadcrumbItem>
      <BreadcrumbSeparator className="px-s2 text-icon-subdued" />
      <HgBreadcrumbListDefault
        breadcrumbs={breadcrumbs.slice(1 + numOverflowBreadcrumbs)}
      />
    </>
  )
}

export default function HgBreadcrumb({
  breadcrumbs,
  ...htmlProps
}: HgBreadcrumbProps) {
  const hasOverflow = breadcrumbs.length > NUM_VISIBLE_BREADCRUMBS
  return (
    <Breadcrumb {...htmlProps}>
      <BreadcrumbList className="flex items-center text-left text-text-subdued arcadia-body-3">
        {hasOverflow ? (
          <HgBreadcrumbListOverflow breadcrumbs={breadcrumbs} />
        ) : (
          <HgBreadcrumbListDefault breadcrumbs={breadcrumbs} />
        )}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
